import "@hotwired/turbo-rails";

import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'

Turbo.session.drive = false;

const application = Application.start()
const controllers = import.meta.glob('../main/js/controllers/**/*_controller.js', { eager: true })
registerControllers(application, controllers)
